import type { ApolloError } from '@apollo/client'
import { GetRoleLevelsDocument, GetRoleLevelsQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type Level = NonNullable<GetRoleLevelsQuery['jobCatalog']['role']>['levels'][number]

type Return = [Level[] | undefined, boolean, () => void, ApolloError | undefined]

export const useRoleLevels = (id: number): Return => {
  const { data, loading, refetch, error } = useQuery(GetRoleLevelsDocument, {
    variables: { id },
  })

  const role = !loading ? data?.jobCatalog.role?.levels : undefined

  return [role, loading, refetch, error]
}
